export default __webpack_public_path__ + "static/media/icon_domain-dns.0a73cd2a.svg";